export const DEFAULT_NUMBER_OF_LOADS = 1;
export const DEFAULT_PAYLOAD_SIZE = 20;
export const DEFAULT_TARGET_MARGIN = 6;
export const DEFAULT_CURRENCY = 'USD';
export const PAGE_SIZE = 6;
export const DEFAULT_RECENT_SIGNALS_LOOKBACK_DAYS = 30;
export const DEFAULT_RECENT_DEALS_LOOKBACK_DAYS = 30;
export const DEFAULT_RECENT_OFFERS_LOOKBACK_DAYS = 7;
export const MAX_BUYER_PRICE_DIFFERENCE_PERCENTAGE = '10';
export const MAX_SELLER_PRICE_DIFFERENCE_PERCENTAGE = '10';
